import AclSelect from '@/components/acl-select/acl-select';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { groupsApi } from '@/providers/apis/groups/groups';
import { rosterAPI } from '@/providers/apis/roster/roster';
import { sessionService } from '@/providers/services/auth/session';
import { copy } from '@/utils/cohort';
import { isAPICatchError, isEmptyValue, sortByProperty } from '@/utils/utils';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';

@Component({
    name: 'schools-page',
    components: {
        'acl-select': AclSelect,
        'date-range-picker': DateRangePicker,
    },
})

export default class SchoolsPage extends Vue {

    public get isPermissionToAdd() {
        return sessionService.isAdminORSuperAdmin() ? true : false;
    }
    public parentDetail: any = null;

    // -----------------------------------------------------------------------
    // Properties

    public fieldsItems: any[] = [
        {
            key: 'index',
            label: 'S.No',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            allowFilter: false,
        },
        {
            key: 'name',
            label: 'School Name',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'code',
            label: 'Code',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'dateLastModified',
            label: 'Last Updated Date',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: true,
        },
        {
            key: 'studentCount',
            label: 'Students Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'teacherCount',
            label: 'Teachers Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'otherCount',
            label: 'Others Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
        {
            key: 'classCount',
            label: 'Classes Count',
            thClass: 'sticky-position custom-alignment',
            tdClass: 'custom-alignment',
            sortable: true,
            allowFilter: false,
        },
    ];

    public orgList: any = [];

    public dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: new Date(),
    };

    public searchItem: any = {};

    public isShowDateFilter: boolean = false;

    public perPage: number = 10;

    public totalRowCounts: number = 10;

    public currentPage: number = 1;

    public contentType: string = 'school';

    public isLoading: boolean = false;

    public limit: number = 10;

    public offset: number = 0;

    public searchTerms: any = {};

    public isSubmitted: boolean = false;

    public selectionALCsList: any = {};

    public selectionALCs: any = {};

    public mixedArray: any = [];

    @Prop()
    public orgData: any;

    public schoolDetailsForm: any = {
        name: {
            name: 'School Name',
            field: 'b-form-input',
            modelKey: 'name',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        code: {
            name: 'School UDISE / NCSE Ids',
            field: 'b-form-input',
            modelKey: 'code',
            modelValue: '',
            validate: { required: true },
            eventBind: { change: this.onSearchCode.bind(this) },
        },
    };

    public isUniqueCode: boolean = false;

    public addSchool: any = {};

    public cohortLevel: any = [];

    public isSearched: any = false;

    public editData: any = {};

    public editSchool: any = {name: '', code: ''};

    public schoolDetailsEditForm: any = {
        name: {
            name: 'School Name',
            field: 'b-form-input',
            modelKey: 'name',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        code: {
            name: 'School Code',
            field: 'b-form-input',
            modelKey: 'code',
            modelValue: '',
            validate: { required: true },
            eventBind: { change: this.onSearchCode.bind(this) },
        },
    };
    public isEdited: boolean = false;
    public errorMsg = '';
    // -----------------------------------------------------------------------
    // Actions

    public onSelectPage(pageNumber: number) {
        this.orgList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.schoolList();
    }

    public onSearch() {
        this.resetProperties();
        this.schoolList();
    }

    public onSelectRow(row: any, columnData = null) {
        row.routePath = this.$route.path;
        row.columnData = columnData;
        this.$emit('onSelectRow', row, 'schoolData');
        this.$router.push(`/users-rosters/${columnData ? 'users' : 'classes'}`);
    }

    public onGoBack() {
        this.$emit('onSelectRow', null, 'org');
        this.$router.push('/users-rosters/orgs');
    }
    public onEdit(row: any, type = null) {
        this.editSchool.code = row.item.code;
        this.editSchool.name = row.item.name;
        const parentObject = this.cohortLevel[this.cohortLevel.length - 1];
        Object.keys(parentObject.child).forEach((data) => {
            const childData = parentObject.child[data].cohortList.find((list: any) => {
                if (list.id === row.item.parentId) {
                    return list.id === row.item.parentId;
                }
            });
            if (childData) {
                this.parentDetail = childData;
            }
        });
        const level = this.cohortLevel;
        let clusterList;
        let blockList;
        let districtList;
        let stateList;
        let countryList;
        if (this.parentDetail && this.parentDetail.parentId && level[4] && level[4].child
            && level[4].child[this.parentDetail.parentId]) {
            clusterList = level[4].child[this.parentDetail.parentId].cohortList
                .find((cohort: any) => cohort.id === this.parentDetail.id);
            if (clusterList && clusterList.parentId) {
                blockList = findParent(level[3], clusterList.parentId);
                if (blockList && blockList.parentId) {
                    districtList = findParent(level[2], blockList.parentId);
                    if (districtList && districtList.parentId) {
                        stateList = findParent(level[1], districtList.parentId);
                        if (stateList && stateList.parentId) {
                            countryList = findParent(level[0], stateList.parentId);
                        }
                    }
                }
            }
        }

        if (countryList) {
            this.onSelectListItem(null, countryList.id, 0);
        }
        if (stateList) {
            this.onSelectListItem(null, stateList.id, 1);
        }
        if (districtList) {
            this.onSelectListItem(null, districtList.id, 2);
        }
        if (blockList) {
            this.onSelectListItem(null, blockList.id, 3);
        }
        if (clusterList) {
            this.onSelectListItem(null, clusterList.id, 4);
        }

        this.$bvModal.show('edit-school');
        this.editData = row;

        function findParent(levelObj: any, parentId: any) {
            for (const key of Object.keys(levelObj.child || {})) {
                const match = levelObj.child[key].cohortList.find((cohort: any) => cohort.id === parseInt(parentId, 10));
                if (match) {
                    return match;
                }
            }
            return null;
        }
    }

    public onChangeInput() {
        if (this.editSchool.name !== this.editData.item.name || this.editSchool.code !== this.editData.item.code) {
            this.isEdited = true;
        } else {
            this.isEdited = false;
        }
    }

    // -----------------------------------------------------------------------
    // Hooks

    public created() {
        this.schoolList();
        this.fetchUserACL();
    }


    // ------------------------------------------------------------------------
    // Methods

    public schoolList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchTerms = this.searchTerms;
        const orgData = this.orgData;
        const params: any = {
            offset,
            limit,
            type: this.contentType,
        };
        for (const key in searchTerms) {
            if (Object.prototype.hasOwnProperty.call(searchTerms, key)) {
                const element = searchTerms[key];
                if (!isEmptyValue(element)) {
                    params[key] = element;
                }
            }
        }
        if (orgData) {
            params.parent_id = orgData.id;
        }
        rosterAPI.getOrgsDetails(params).then((data) => {
            this.isLoading = false;
            if (!isAPICatchError(data)) {
                this.orgList = data.orgs;
                this.totalRowCounts = data.totalCounts;
            }
        });
    }

    public resetProperties() {
        this.orgList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    public showAddSchoolPopup() {
        this.addSchool = {};
        this.isSubmitted = false;
        this.$bvModal.show('add-school');
    }

    public hideSchoolModal() {
        this.$bvModal.hide('add-school');
    }

    public inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    public createSchool() {
        this.isSubmitted = true;
        this.$validator.validate().then((valid) => {
            if (valid && this.isUniqueCode) {
                const params: any = {
                    name: this.addSchool.name,
                    code: this.addSchool.code,
                    type: 'school',
                    parent_id: this.selectionALCs[this.cohortLevel.length],
                };
                const payload = {
                    school: [params],
                };
                adminUtilsAPI.addSchool(payload).then((data: any) => {
                    if (!isAPICatchError(data)) {
                        this.schoolList();
                        this.hideSchoolModal();
                    }
                });
            }
        });
    }

    public fetchUserACL() {
        groupsApi.fetchUserHierarchies().then((hierarchy: any) => {
            sortByProperty(hierarchy[0].levels, 'sequence', 'ASC');
            const schoolSeq = hierarchy[0].levels.find((item: any) => {
                return item.type === 'school';
            });
            if (schoolSeq && schoolSeq.sequence) {
                hierarchy[0].levels = hierarchy[0].levels.filter((item: any) => {
                    return item.sequence < schoolSeq.sequence;
                });
            }
            this.cohortLevel = hierarchy[0].levels;
            this.fetchCohortListAll();
        });
    }

    public async fetchCohortListAll() {
        this.isLoading = true;
        const levels: any = copy(this.cohortLevel);
        for await (const [index, iterator] of levels.entries()) {
            iterator.child = {};
            iterator.child = await groupsApi.fetchGroupedHierarchyMapping({ type: iterator.type });
            this.selectionALCs[iterator.sequence] = '';
            if (iterator.sequence === 1) {
                this.selectionALCsList[iterator.sequence] = iterator.child[0].cohortList;
                this.selectionALCs[iterator.sequence] = 0;
            }
            if (index === levels.length - 1) {
                this.isLoading = false;
                this.cohortLevel = levels;
            }
        }
    }

    public onSelectListItem(type: any, selectedId: any, index: any) {
        const selected = this.cohortLevel[index + 1];
        this.$set(this.selectionALCs, this.cohortLevel[index].sequence, selectedId);
        if (selected && selected.sequence) {
            if(selected.child[selectedId]){
                this.$set(this.selectionALCsList, selected.sequence, selected.child[selectedId].cohortList);
            } else {
                this.$set(this.selectionALCsList, selected.sequence, []);
            }
        }
    }

    public onSearchCode() {
        const params: any = {
            offset: 0,
            limit: 10,
            search_group_code: this.addSchool.code,
            type: this.contentType,
        };
        rosterAPI.getOrgsDetails(params).then((data) => {
            this.isUniqueCode = false;
            if (!isAPICatchError(data)) {
                if (data.orgs.length === 0) {
                    this.isUniqueCode = true;
                } else {
                    const itemIndex = data.orgs.findIndex((item: any) => item.code === this.addSchool.code);
                    if (itemIndex === -1) {
                        this.isUniqueCode = true;
                    } else {
                        this.isUniqueCode = false;
                    }
                }
            }
        });
    }

    public showDateFilter() {
        this.isShowDateFilter = true;
        setTimeout(() => {
            const datePick: any = this.$refs.picker as HTMLElement;
            if (datePick) {
                datePick[0].togglePicker(true);
            }
        }, 200);
    }

    public updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        this.searchTerms.modified_at = `${moment(dataRange.startDate).format('YYYY-MM-DD')}`;
        this.onSearch();
    }

    public removeDateFilter() {
        this.isShowDateFilter = false;
        this.dateRange = {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: new Date(),
        };
        this.searchTerms.modified_at = '';
        this.onSearch();
    }

    public dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const b = new Date();
            classes.disabled = moment(a).isAfter(b);
        }
        return classes;
    }

    public searchTable(searchText: any, searchKey: any) {
        const that = this;
        if (searchText.length >= 3 || isEmptyValue(searchText)) {
            switch (searchKey) {
                case 'name':
                    this.searchTerms.search_group_name = searchText;
                    break;
                case 'code':
                    this.searchTerms.search_group_code = searchText;
                    break;
                case 'referenceId':
                    this.searchTerms.search_group_sourced_id = searchText;
                    break;
                default:
                    break;
            }
            if (!that.isSearched) {
                that.isSearched = true;
                setTimeout(() => {
                    that.isSearched = false;
                    that.onSearch();
                }, 1000);
            }
        }
    }

    public removeDate(searchText: any, searchKey: any) {
        switch (searchKey) {
            case 'name':
                this.searchTerms.search_group_name = '';
                this.searchItem.name = '';
                break;
            case 'code':
                this.searchTerms.search_group_code = '';
                this.searchItem.code = '';
                break;
            case 'referenceId':
                this.searchTerms.search_group_sourced_id = '';
                this.searchItem.referenceId = '';
                break;
            default:
                break;
        }
        this.onSearch();
    }
    public hideEditSchoolModal() {
        this.$bvModal.hide('edit-school');
        this.editSchool.code = '';
        this.editSchool.name = '';
        this.errorMsg = '';
    }

    public saveSchool() {
        this.isSubmitted = true;
        let params: any;
        if (!this.editSchool.name || !this.editSchool.code) {
            return;
        }
        params = {
            name: this.editSchool.name,
            code: this.editSchool.code,
        };
        const parentId = this.selectionALCs[
            Object.keys(this.selectionALCs)[Object.keys(this.selectionALCs).length - 1]
        ];
        if (parentId) {
            params.parentId = parentId;
        }
        adminUtilsAPI.updateGroup(params, this.editData.item.id).then((data) => {
            if (data.statusCode === 400) {
                this.errorMsg = data.message;
            } else {
                if (!isAPICatchError(data)) {
                    this.schoolList();
                    this.hideEditSchoolModal();
                    this.fetchCohortListAll();
                }
            }
        });
    }
}
